import { useState, useCallback, useMemo } from 'react';
import { cidImageReplacer } from "v4/components/form/Field/components/InputRichText/utils/CidImageReplacer";

/**
 * Hook to handle CID image replacement progressively.
 * It uses a global cache to avoid redundant fetches.
 * 
 * @param {string} html - The HTML content containing cid: links or data-cid attributes.
 * @param {Array} files - The files metadata to resolve CID to file IDs.
 * @returns {Object} { processedValue, revert, prepare }
 */
export default function useCidImages(html, files = []) {
    const [refresh, setRefresh] = useState(0);
    const forceUpdate = useCallback(() => setRefresh(r => r + 1), []);

    // Processed value with blobs (synced progressively as they arrive in cache)
    const processedValue = useMemo(() => {
        return cidImageReplacer.sync(html, files, forceUpdate);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [html, files, forceUpdate, refresh]);

    const revert = useCallback((content) => cidImageReplacer.revert(content), []);
    const prepare = useCallback((content) => cidImageReplacer.prepare(content), []);

    return {
        processedValue,
        revert,
        prepare
    };
}
